(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicesJapanReportController', InvoicesJapanReportController);

    InvoicesJapanReportController.$inject = ['$scope', '$uibModal', 'InvoiceCustomService', 'ToastrService', 'MiscService', 'XLSXExportService', 'DateUtils'];

    function InvoicesJapanReportController ($scope, $uibModal, InvoiceCustomService, ToastrService, MiscService, XLSXExportService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.downloadReport = downloadReport;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.copyStartDate = copyStartDate;
        vm.returnInvoiceValue = returnInvoiceValue;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.invoicesList = [];
        vm.startDate = MiscService.generateStartDate( new Date() );
        vm.endDate = MiscService.generateEndDate( new Date() );
        vm.statusText = "Waiting for Command...";

        function loadAll() {
            vm.invoicesList.length = 0;
            vm.statusText = "Fetching Invoices";
            InvoiceCustomService.returnJapanInvoicesReport( DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate) ).then(function( result ) {
                vm.invoicesList = result.data;
                if( vm.invoicesList.length === 0 ) {
                    ToastrService.info("No Invoices fetched for Japan Report", "Info");
                }
                generateStatusText();
            }, function( error ) {
                vm.invoicesList.length = 0;
                if( error.status !== "404" ) {
                    ToastrService.error("Failed to fetch Invoices for Japan Report", "Error");
                }
                vm.statusText = "Failed to fetch Invoices for Japan Report";
            });
        }

        function downloadReport() {
            if( vm.invoicesList.length > 0 ) {
                XLSXExportService.downloadJapanInvoicesReport( DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate) ).then( function( data, status, headers, config ) {
                    var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    saveAs( file, "JapanDailyInvoiceReport.xls" );
                }, function( error ) {
                    if( error.status !== "404" ) {
                        ToastrService.error("Failed to download Japan Invoices Report", "Error!");
                    }
                });
            } else {
                ToastrService.info("Nothing to download", "Info");
            }
        }

        function refresh() {
            loadAll();
        }

        function onStartDateChange() {
            vm.endDate = MiscService.onStartDateChange( vm.startDate, vm.endDate );
        }

        function copyStartDate() {
            vm.endDate = vm.startDate;
        }

        function generateStatusText() {
            if( vm.startDate.getTime() === vm.endDate.getTime() ) {
                vm.statusText = "Showing " + vm.invoicesList.length + " Invoices for " + vm.startDate.toLocaleDateString("en-US");
            } else {
                vm.statusText = "Showing " + vm.invoicesList.length + " Invoices from " + vm.startDate.toLocaleDateString("en-US") + " to " + vm.endDate.toLocaleDateString("en-US");
            }
        }

        function returnInvoiceValue( val1, val2 ) {
            var returnMe = parseFloat(val1) + parseFloat(val2);
            return parseFloat(returnMe.toString()).toFixed(2);
        }
    }
})();
